import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import ReusableContactForm from '../components/ReusableContactForm/ReusableContactForm';
import styles from './Portfolios.module.css';

import architecutralImage from '../assets/images/architectural-series.webp';
import builderImage from '../assets/images/builder-series.webp';
import commercialImage from '../assets/images/commercial-series.webp';

const Portfolios = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();
  const currentHost = window.location.host.replace(/^www\./, ''); // For handling the BGRS subdomain

  const handleTouchStart = (index) => {
    setActiveIndex(index);
  };

  const handleTouchEnd = () => {
    setActiveIndex(null);
  };

  const imageData = [
    {
      href: "/architectural",
      src: architecutralImage,
      alt: "Architectural Series",
      title: "Architectural Series",
      description:
        "Experience the pinnacle of elegance with our Architectural Series. Crafted from premium aluminum and iron alloys, these powder-coated railings are perfect for both exterior and interior applications, redefining luxury and sophistication.",
    },
    {
      href: `https://bgrs.${currentHost}`,
      src: builderImage,
      alt: "Builder Series",
      title: "Builder Series",
      description:
        "Discover the perfect blend of affordability and style with our Builder Series. Made exclusively from aluminum alloys and available in textured black and gloss white powder coatings, these railings offer a premium look at a builder-friendly price.",
      target: "_blank",
      rel: "noopener noreferrer"
    },
    {
      href: "/commercial",
      src: commercialImage,
      alt: "Commercial Series",
      title: "Commercial Series",
      description:
        "Choose durability and compliance with our Commercial Series. Designed to meet stringent building codes without compromising on style, they offer reliability and longevity, making them the perfect choice for any commercial application.",
    },
  ];

  return (
    <div className={styles.container}>
      <Helmet>
        <title>Our Portfolios - ABC Railing</title>
        <meta name="description" content="Explore our portfolio of premium railing solutions. From architectural masterpieces to commercial projects, see our work in action." />
      </Helmet>

      <section className={styles.whoWeAreSection}>
        <div className={styles.sectionContent}>
          <h2>Our Portfolio</h2>
          <p>Explore our premium collection of railing solutions designed to enhance any space with style and safety.</p>
        </div>
      </section>

      <section id="portfolios" className={styles.seriesSection}>
        <div className={styles.imageContainer}>
          {imageData.map((image, index) => (
            <div
              key={index}
              className={`${styles.imageWrapper} ${activeIndex === index ? styles.active : ''}`}
              onTouchStart={() => handleTouchStart(index)}
              onTouchEnd={handleTouchEnd}
            >
              <a
                href={image.href}
                target={image.target || '_self'}
                rel={image.rel || 'noopener noreferrer'}
                aria-label={image.title}
              >
                <img src={image.src} alt={image.alt} className={styles.image} />
                <div className={styles.imageOverlay}>
                  <h3 className={styles.imageTitle}>{image.title}</h3>
                  <p className={styles.imageDescription}>{image.description}</p>
                </div>
              </a>
            </div>
          ))}
        </div>
      </section>

      <section className={styles.consultationSection}>
        <div className={styles.consultationContent}>
          <div className={styles.consultationText}>
            <h2>Ready to Start Your Project?</h2>
            <p>Get expert guidance on the perfect railing solution for your space. Our team is ready to help bring your vision to life.</p>
          </div>
          <div className={styles.contactFormSection}>
            <ReusableContactForm
              title="Request a Quote"
              compact={true}
              className={styles.consultationContactForm}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolios;
